import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledTooltip } from 'reactstrap';

import { imagePath } from '../../utilities/UrlPaths';

const AuctionGroupHeader = ({ groupName, live, showUnsoldBadge, groupId }) => {
  let groupNameWidthClass = 'text-truncate d-inline-block ml-3';
  groupNameWidthClass += showUnsoldBadge ? ' mw-30' : ' mw-35';

  const timedToolTipText = 'When you opt-in for this feature, we will automatically re-list your unsold items in a timed catalog. Be sure to review and publish your sale - there is no additional fee!';
  return (
    <Fragment>
      <div className="align-top d-inline-block">
        {showUnsoldBadge && (
          <img className="ml-n2 mr-2" src={`${imagePath}/images/BadgeNew.png`} alt="New" />
        )}
        <FontAwesomeIcon icon={live ? 'rss' : 'clock'} />{' '}
        <strong>{live ? 'Live' : 'Timed'} Auction</strong>
      </div>
      <div className={groupNameWidthClass}>{groupName}</div>

      {!live && showUnsoldBadge && (
        <span className="align-top d-inline-block ml-2">
          <FontAwesomeIcon icon="question-circle" id={`timedToolTip_${groupId}`} />
          <UncontrolledTooltip placement="right" target={`timedToolTip_${groupId}`}>
            {timedToolTipText}
          </UncontrolledTooltip>
        </span>
      )}
    </Fragment>
  );
};

export default AuctionGroupHeader;
